export default __webpack_public_path__ + "static/media/logo.3e0a00da.svg";